import { CollapseTransition } from 'vue2-transitions'
import messages from './MenuUtilisateur.json'

export default {
    name: "MenuUtilisateur",

    i18n: messages,

    components: {
        CollapseTransition
    },

    data() {
        return {
            isClosed: true,

            // Données reçues du back
            data: null
        }
    },

    mounted() {
        this.updateData();
    },

    methods: {
        /**
         * gére l'affichage/masquage du bandeau de gauche
         */
        toggleMenu() {
            this.isClosed = !this.isClosed
        },

        /**
         * récupération des données
         */
        updateData() {
            this.$axios.get('rest/bd/utilisateur/' + this.$store.getters.user.id).then(
                response => {
                    this.updateDataSuccess(response.data)
                },
                error => {
                    this.updateDataFailed(error.response)
                }
            )
        },

        /**
         * appelé lorsque la récupération des données s'est bien passée
         */
        updateDataSuccess(data) {
            this.data = data
        },

        /**
         * appelé lorsque la récupération des données s'est mal passée
         */
        updateDataFailed(error) {
            //on notifie l'erreur a l'utilisateur
            this.$notify({
                title: this.$t('notifications.title.erreur'),
                message: this.$t('notifications.message.echecRecuperationDonnees'),
                horizontalAlign: 'right',
                verticalAlign: 'bottom',
                type: 'danger', // info | warning | danger | success | primary
                timeout: 5000,
                closeOnClick: true
            })
        }
    }
}
